
export default class Currency {
  static fromJSON (json) {
    return new Currency({
      code: json.code,
      name: json.name,
      exchangeRate: json.exchangeRate
    })
  }

  constructor ({ code, name, exchangeRate }) {
    this.code = code
    this.name = name
    this.exchangeRate = exchangeRate
  }
}
